import React from 'react';
import { jumpTo } from '@/navigate'
import './index.scss';
import Anim from '../anim';
import http from '@/services/http';
import { inject, observer } from "mobx-react";
@inject("ScoreStore")
@observer
class App extends React.Component {
    state = {
        username: '',
        password: '',
        needLogin: false,
        sessionId: ""
    }
    changeInput(type, e) {
        this.setState({
            [type]: e.target.value
        })
    }
    skipLogin = () => {
        // let { username, password } = this.state;
        // if (username == '123456' && password == '123456') {
        //     jumpTo('guide1');
        // }
        this.props.ScoreStore.setType(true);
        jumpTo('guide1');
    }
    showLogin = () => {
        this.setState({
            needLogin: true
        })
        // jumpTo('guide1');
    }
    componentDidMount() {
        this.getSession()
        this.animInit()
        // let token = window.httpQuery.token;
        // if (!token) {
        //     let a = new Anim();
        //     a.init(this.refs.container);
        //     this.anim = a;
        //     return;
        // }
        //判定当前是否实验空间登录，如果是解析用户信息
        // this.ilabxLogin();
    }
    animInit() {
        let a = new Anim();
        a.init(this.refs.container);
        this.anim = a;
    }
    subLogin = async () => {
        let res = await http.login({
            identity: this.state.username,
            desStr: this.state.password,
            sessionId: this.state.sessionId
        })
        if (res.code == 200) {
            localStorage.setItem('startDate', Date.now());
            localStorage.setItem('loginToken', res.data["APP-Auth-Token"]);          
            jumpTo('guide1');
        }
        else {
            alert(res.message)
        }
    }
    async getSession() {
        let res = await http.getSessionId();
        if (res.code == 200) {
            this.setState({
                sessionId: res.data.sessionId
            })
        }
    }

    async ilabxLogin() {
        let token = window.httpQuery.token;
        if (!token) {
            return;
        }




        // // this.showLoading();
        // let ret = await http.ilabxLogin({ token });

        // if (ret.errorNo == 200) {
        //     
        //     // this.bridage.pageState.name = ret.result.payload.dis;
        //     // this.bridage.pageState.ilabx = true;
        //     localStorage.setItem('startDate', Date.now());


        // } else {
        //     // location.reload();

        // }
    }

    render() {
        return (
            <div className="page page-guide guide">
                <div className="logoBox">
                    <img src={require('../../assets/images/logo_1.png')} alt="" className="logoBox-img1" />
                    <span className="logoBox-split"></span>
                    <img src={require('../../assets/images/logo_2.png')} alt="" className="logoBox-img2" />
                    <span className="logobox-txt">针灸推拿学院/第三附属医院</span>
                </div>
                <div className="chrome_tips">
                    推荐：使用Google浏览器，按F11进入全屏模式
                </div>
                <div className="loginBox">
                    <div className="login_img_view" ref="container">
                    </div>
                    <div className="login_conent">
                        {this.state.needLogin ? <div className="loginForm"><div className="top_view"><span>用户登录</span></div>
                            <div className="loginItem">
                                <img src={require('../../assets/images/user.png')} alt="" className="userIcon" />
                                <input type="text" className="userInput" placeholder="账户" value={this.state.username} onChange={this.changeInput.bind(this, 'username')} />
                            </div>
                            <div className="loginItem">
                                <img src={require('../../assets/images/pwd.png')} alt="" className="pwdIcon" />
                                <input type="password" className="pwdInput" placeholder="密码" value={this.state.password} onChange={this.changeInput.bind(this, 'password')} />
                            </div>
                            <div className="login_btn" onClick={this.subLogin}>
                                确认登录
                            </div>

                        </div> : <div className="loginForm">

                                <div className="top_view"><span>选择训练模式</span></div>
                                <div className="btn_view">
                                    <div className="button" onClick={this.skipLogin}>
                                        <img src={require('../../assets/images/icon_type1.png')} />
                                        <span>学习模式</span>

                                    </div>
                                    <div className="button glost" onClick={this.showLogin}>
                                        <img src={require('../../assets/images/icon_type2.png')} />
                                        <span>考试模式</span>
                                    </div>
                                </div>

                            </div>}

                    </div>
                </div>

            </div >
        );
    }
}

export default App;
